import { Profile } from "@setel/web-app-sdk";
import { isIFrame } from "./helper/isIFrame";

export const autoStartChat = (
  loginState: string,
  profile: Profile | undefined
) => {
  if (
    loginState === "authorized" &&
    profile?.email &&
    profile?.phone &&
    document
  ) {
    const timer = setInterval(() => {
      let frame = document.getElementById("webWidget");
      if (isIFrame(frame) && frame.contentWindow) {
        let startChatElement = frame.contentWindow.document.querySelector(
          'button[type="submit"]'
        ) as HTMLButtonElement;
        if (startChatElement && startChatElement.textContent !== "Send") {
          startChatElement?.click();
        }
        if (startChatElement) {
          clearInterval(timer);
        }
      }
    }, 300);
  }
};
